export const selectInput = {
  color: "#6d9e93",
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "#6d9e93",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6d9e93",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6d9e93",
  },
};

export const inputLabel = {
  color: "#6d9e93",
  "&.Mui-focused": {
    color: "#6d9e93",
  },
};

export const TextInputStyle = {
  "& label.Mui-focused": {
    color: "#6d9e93",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#6d9e93",
    },
    "&:hover fieldset": {
      borderColor: "#6d9e93",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#6d9e93",
    },
  },
};

export const CheckboxStyle = {
  color: "#FFFFFF",
  "&.Mui-checked": { color: "#FFFFFF" },
  "& .MuiSvgIcon-root": { fontSize: 35 },
  "& .MuiFormControlLabel-label": { color: "#FFFFFF", fontSize:"14px" }
};
